import { Injectable, inject } from '@angular/core';
import { GraphTooltipService } from '@molecules/graph-tooltip/graph-tooltip.service';
import { CpCompareScaleService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-header/cp-compare-scale/cp-compare-scale.service';
import { CpCompareSidebarService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar.service';

@Injectable()
export class CpCompareGraphTooltipService extends GraphTooltipService {
  protected compareSidebarService = inject(CpCompareSidebarService);
  protected compareScaleService = inject(CpCompareScaleService);

  measureCards$ = this.compareSidebarService.measureCards$;
  apiScale$ = this.compareScaleService.apiScale$;

  constructor() {
    super();
    this.createTooltip('cursor');
  }
}